import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import myOrdersReducer from './myOrdersSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    myOrders: myOrdersReducer,
  },
});